import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import { api, errMsg } from "../lib/api";

const sel = "h-8 border bg-white px-1.5 text-xs rounded-sm";

const Looks = ({ items }) => (
  <div className="flex gap-3 overflow-x-auto py-2" data-testid="lucy-festival-looks">
    {items.map((f) => (
      <figure key={f.key} className="shrink-0 w-20 text-center" data-testid={`lucy-festival-look-${f.key}`}>
        <img src={f.image} alt={`Lucy dressed for ${f.name}`} className="h-16 w-16 rounded-full object-cover mx-auto lucy-face" />
        <figcaption className="text-[11px] mt-1.5 leading-tight">{f.name}</figcaption>
      </figure>
    ))}
  </div>
);

const Row = ({ r, i, fests, today, set, drop }) => (
  <div className={`flex flex-wrap items-center gap-2 py-1.5 border-b last:border-0 ${r.date && r.date < today ? "opacity-50" : ""}`} data-testid={`lucy-festival-row-${i}`}>
    <select className={`${sel} w-40`} value={r.key} onChange={(e) => set(i, { key: e.target.value })} data-testid={`lucy-festival-key-${i}`}>
      {fests.map((f) => <option key={f.key} value={f.key}>{f.name}</option>)}
    </select>
    <input type="date" className={`${sel} w-40`} value={r.date} onChange={(e) => set(i, { date: e.target.value })} data-testid={`lucy-festival-date-${i}`} />
    {r.date === today && <span className="text-[11px] font-medium text-amber-800 bg-amber-100 rounded-full px-2 py-0.5" data-testid={`lucy-festival-today-${i}`}>Today</span>}
    <button type="button" onClick={() => drop(i)} className="text-muted-foreground hover:text-destructive p-1" title="Remove this date" data-testid={`lucy-festival-remove-${i}`}><Trash2 className="h-3.5 w-3.5" /></button>
  </div>
);

export const LucyFestivals = () => {
  const [d, setD] = useState(null);
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/lucy-festivals").then((r) => { setD(r.data); setRows(r.data.dates); }).catch(() => {}); }, []);
  if (!d) return null;
  const dirty = JSON.stringify(rows) !== JSON.stringify(d.dates);
  const set = (i, patch) => setRows(rows.map((r, j) => (j === i ? { ...r, ...patch } : r)));
  const save = () => {
    if (rows.some((r) => !r.date)) { toast.error("Pick a date for every festival row"); return; }
    setBusy(true);
    api.put("/admin/lucy-festivals", { dates: rows }).then((r) => { setD({ ...d, dates: r.data.dates }); setRows(r.data.dates); toast.success("Festival dates saved"); })
      .catch((e) => toast.error(errMsg(e))).finally(() => setBusy(false));
  };
  return (
    <section className="ax-panel p-4 mb-4" data-testid="lucy-festivals-panel">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0 flex-1"><div className="font-medium text-sm">Lucy's festival days</div>
          <p className="text-xs text-muted-foreground">On these days Lucy wears her festival outfit and wishes the team in her panel, tips card and morning email. Diwali, Holi and Eid move every year, and Eid can shift a day with the moon, so check the dates each year.</p></div>
        <button type="button" data-testid="lucy-festival-save" disabled={!dirty || busy} onClick={save} className="h-9 px-4 text-sm bg-primary text-primary-foreground disabled:opacity-50">Save festival dates</button>
      </div>
      <Looks items={d.festivals} />
      <div className="mt-1">{rows.map((r, i) => <Row key={`${i}-${r.key}`} r={r} i={i} fests={d.festivals} today={d.today} set={set} drop={(j) => setRows(rows.filter((_, k) => k !== j))} />)}</div>
      <button type="button" data-testid="lucy-festival-add" onClick={() => setRows([...rows, { key: d.festivals[0].key, date: "" }])} className="mt-2 h-8 px-3 text-xs border hover:border-primary inline-flex items-center">
        <Plus className="h-3.5 w-3.5 mr-1" />Add a date
      </button>
    </section>
  );
};
